export default {
  checkMobile(context) {
    context.commit('checkMobile');
  }
}